import "./App.css";

import { useEffect, useState } from "react";
import Footer from "./components/footer/index";
import Home from "./pages/home/page";
import PaymentDetail from "./pages/detail/page";

import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { LocalStorageService } from "./helpers";
import "./i18n";
import NotFound from "./pages/404page/page";
import useConfigEnv from "./zustand";

function App() {
  const [school, setSchool] = useState("Tra cứu thông tin");
  const [logo, setLogo] = useState("");
  const accessTokenExp = LocalStorageService.getAccessToken();
  const { setEnv, env }: any = useConfigEnv();

  // Load environment config
  useEffect(() => {
    const ac = new AbortController();
    (async () => {
      try {
        const res = await fetch("/env.json", { signal: ac.signal });
        if (!res.ok) throw new Error(`Failed to load /env.json: ${res.status}`);
        const config = await res.json();
        // console.log("config", config);
        setEnv(config);
      } catch (err) {
        if ((err as any)?.name !== "AbortError") {
          console.error("Error loading env:", err);
        }
      }
    })();

    return () => ac.abort();
  }, []);

  // Fetch school data
  useEffect(() => {
    if (!env?.apiCall) return;

    const ac = new AbortController();
    (async () => {
      try {
        const response = await fetch(`${env.apiCall}`, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          signal: ac.signal, // ← Đã sửa: chỉ có 1 signal
          body: JSON.stringify({
            model: "res.company",
            method: "web_read",
            ids: [1],
            kwargs: {
              specification: {
                primary_color: {},
                secondary_color: {},
                logo: {},
                display_name: {},
              },
            },
          }),
        });

        if (!response.ok) {
          setSchool("Tra cứu thông tin");
          return;
        }

        const data = await response.json();
        const row = Array.isArray(data) ? data[0] : data;
        setSchool(row?.display_name || "Tra cứu thông tin");
        setLogo(row?.logo || null);

        // ← Đã sửa: chỉ có 1 logic xử lý
        if (row?.primary_color) {
          document.documentElement.style.setProperty(
            "--color-primary",
            row.primary_color
          );
        }
      } catch (error: any) {
        if (error?.name !== "AbortError") {
          console.error("Error fetching schools:", error);
          setSchool("Tra cứu thông tin");
        }
      }
    })();

    return () => ac.abort();
  }, [env?.apiCall]); // ← Đã sửa: dependency đúng và chỉ có 1 useEffect

  const shouldRedirectToPayment = () => {
    return accessTokenExp && env.loginGG === "true";
  };

  return (
    <Router>
      <div className="App">
        <div className="font-inter-display min-h-[100vh]">
          <main className="md:min-h-[calc(100vh-42px)] min-h-[calc(100vh-78px)]">
            <Routes>
              <Route
                path="/"
                element={
                  shouldRedirectToPayment() ? (
                    <Navigate to="/payment/detail" replace />
                  ) : (
                    <Home school={school} logo={logo} />
                  )
                }
              />
              <Route
                path="/payment/detail"
                element={<PaymentDetail logo={logo} />}
              />
              <Route path="/404page" element={<NotFound logo={logo} />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </div>
    </Router>
  );
}

export default App;
